import React, {FC} from "react";
import classNames from "classnames";
import defaultImage from "../../images/defaultpic.webp";
import {createRightDate, replaceDescr} from "../../services/utils";
import cls from "./posts.module.scss"
import {domainUrl} from "../../helper";
import Image from "next/image";
import {IPost, ITag} from "../../types/posts";
import SMSharedButton from "../shared/SMSharedButton";
import {useRouter} from "next/router";
import {PostShareSvg} from "../../svg";
import {TranslationsType} from "../../types/homePageTypes";

interface IBlogPostProps {
    post?: IPost,
    postTags: Array<ITag>
    dbName: string,
    domain: string,
    layout?: string,
    translationsData: TranslationsType;
}

const Post: FC<IBlogPostProps> = ({
                                      layout,
                                      post,
                                      domain,
                                      dbName,
                                      postTags,
                                      translationsData
                                  }) => {
    const router = useRouter()

    const postClasses = classNames(cls.typography,
        layout === "full" && cls["typography--expanded"]
    );

    if (!post) {
        return <></>;
    }
    const createMarkup = (item: string) => {
        return {__html: item};
    };

    const rightDay = {
        true: {
            true: createRightDate(post?.published_at),
            false: createRightDate(post?.published_at)
        },
        false: {
            true: createRightDate(post?.updated_at),
            false: createRightDate(post?.created_at)
        }
    }

    const postImage = typeof post.image === "string" ? post.image : "";
    const blogDefaultImage = postImage
        ? domainUrl(`${dbName}/storage/${domain}/${postImage}`)
        : domainUrl(`${dbName}${defaultImage.src}`);
    const safePostTags = Array.isArray(postTags) ? postTags : [];

    return (
        <div className={`block ${cls.post_container}`}>
            <div
                className={cls[`post-header--layout--${layout}`]}
            >
                <h1 className={cls["post-header__title"]}>
                    {post.name}
                </h1>
                <div className={cls["post-header__meta"]}>
                    <div
                        className={cls["post-header__meta-item"]}> {rightDay[`${!!post?.published_at}`][`${!!post?.updated_at}`]}</div>
                </div>
            </div>

            <div className={cls.post__featured}>
                <Image
                    src={blogDefaultImage}
                    alt="Post Image"
                    placeholder="blur"
                    layout="fill"
                    priority
                    blurDataURL={`/zega/blur1.webp`}
                />
            </div>

            <div className={cls.tags_container}>
                {
                    safePostTags.map(tag => {
                        return <div key={tag.id} className={cls.tag}>
                            {tag.name}
                        </div>
                    })
                }
            </div>

            <div className={postClasses}
                 dangerouslySetInnerHTML={createMarkup(replaceDescr(post.description))}
            />

            <div className={cls.share_container}>
                <div className={cls.share_text}>
                    <PostShareSvg/>
                    <span>
                        {translationsData.PostShare}
                    </span>
                </div>
                <div className={cls.share_icons}>
                    <SMSharedButton url={`https://${dbName}${router.asPath}`}/>
                </div>
            </div>
        </div>
    );
}

export default Post